
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { runDiagnostics } from './utils/diagnostics.ts'
import { diagnoseGoogleMapsApiKey } from './utils/googleMapsKey.ts'

// Run diagnostics on startup to help troubleshoot environment issues
console.log('Tribal Trails.ai - Initializing application');

// Run Google Maps API key diagnostics
console.log('Checking Google Maps API key...');
diagnoseGoogleMapsApiKey();

// More detailed startup diagnostics for Google Maps API key
console.group('🔑 Environment Variables Check');
const googleMapsApiKey = import.meta?.env?.VITE_GOOGLE_MAPS_API_KEY;
console.log('VITE_GOOGLE_MAPS_API_KEY present:', !!googleMapsApiKey);
if (googleMapsApiKey) {
  console.log('VITE_GOOGLE_MAPS_API_KEY length:', googleMapsApiKey.length);
  console.log('VITE_GOOGLE_MAPS_API_KEY format check:', 
    googleMapsApiKey.startsWith('AIza') ? 
    'Valid (starts with AIza)' : 
    'Invalid (should start with AIza)');
  
  // Safely log the first few characters
  if (googleMapsApiKey.length > 8) {
    console.log('VITE_GOOGLE_MAPS_API_KEY preview:', 
      `${googleMapsApiKey.substring(0, 6)}...`);
  }
}
console.log('Current hostname:', window.location.host);
console.groupEnd();

// Run full diagnostics
const diagnosticResults = runDiagnostics();
console.log('Full diagnostics results:', diagnosticResults);

createRoot(document.getElementById("root")!).render(<App />);
